export default __webpack_public_path__ + "static/media/cards_search_instructions_dark.1dbfc109.svg";